import createEvaluationsHook from './createEvaluationsHook';

export default createEvaluationsHook('evaluationProjectEducator', 'project', { completed: true });
